// 💾 Variables
const selects = document.querySelectorAll("[data-select]");

// 📐 Functions
const selectOpen = (select) => {
  select.classList.add("open");
  const menu = select.querySelector("[data-select-menu]");
  menu.classList.add("select__menu--open");
};

const selectClose = (select) => {
  select.classList.remove("open");
  const menu = select.querySelector("[data-select-menu]");
  menu.classList.remove("select__menu--open");
};

const selectToggle = (select) => {
  if (select.classList.contains("open")) {
    selectClose(select);
  } else {
    selectOpen(select);
  }
};

const selectUpdateValue = (select, option) => {
  const label = option.querySelector("button").textContent;
  const value = option.getAttribute("data-select-option");
  const input = select.querySelector("[data-select-value]");
  const inputRead = select.querySelector("[data-select-readonly");
  input.value = value;
  inputRead.value = label;

  select.querySelectorAll("[data-select-option]").forEach((opt) => {
    opt
      .querySelector("[data-input-phone-option-checkmark]")
      .classList.add("hidden");
  });

  option
    .querySelector("[data-input-phone-option-checkmark]")
    .classList.remove("hidden");

  const event = new Event("input", { bubbles: true });
  input.dispatchEvent(event);
};

// 🖱️ Event listeners
if (selects.length !== 0) {
  Array.from(selects).forEach((select) => {
    const currentValue = select.querySelector("[data-select-value]").value;
    const trigger = select.querySelector("[data-input-trigger-open]");
    const options = select.querySelectorAll("[data-select-option]");

    // Init value
    if (currentValue) {
      const selectedOption = select.querySelector(
        `[data-select-option=${CSS.escape(currentValue)}]`,
      );
      selectUpdateValue(select, selectedOption);
    }

    trigger.addEventListener("click", (e) => {
      e.stopPropagation();
      selectToggle(select);
    });

    Array.from(options).forEach((option) => {
      option.addEventListener("click", (e) => {
        e.preventDefault();

        // Update value on change
        selectUpdateValue(select, option);
        selectClose(select);
      });
    });

    document.addEventListener("click", (e) => {
      if (!select.contains(e.target)) {
        selectClose(select);
      }
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        selectClose(select);
      }
    });
  });
}
